module.exports = __webpack_public_path__ + "media/showreel.05669544.mp4";